import { createPinia, PiniaVuePlugin } from "pinia";
import Vue from "vue";

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

export default pinia;

export * from "./auth";
export * from "./catalog";
export * from "./cognitoAdmin";
export * from "./metadataCatalog";
export * from "./reviewCatalog";
export * from "./userAdmin";
